<div class="p-grid" *ngIf="loading">
  <div>
    <span class="counter-title">Expenses</span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter payee" (click)="navigateToTask()" title="Submitted">
      {{counters?.PayeeAmount | currency}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter approved" (click)="navigateToTask()" title="Approved">
      {{counters?.ApprovedAmount | currency}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter paid" (click)="navigateToTask()" title="Paid">
      {{counters?.PaidAmount | currency}}
    </span>
  </div>
</div>